import React, { useContext, useMemo } from 'react';
import { KodplanContext } from '../../../../../../Components/KodplanManager/Context/KodplanContext';
import KonteringContext from '../../../../_Common/Components/KonteringManager/KonteringContext';
import {
  IKontodel,
  IKontodelDef,
} from '../../../../_Common/Components/KonteringManager/Query/KonteringManagerQuery';

interface IProps {
  ordningsNr: number;
  children: (
    kontoDelar: IKontodel[] | null,
    kontoDelDef: IKontodelDef | undefined
  ) => React.ReactElement<any>;
}

const GetKontoDelFromOrdningsNr: React.FC<IProps> = props => {
  const konteringContext = useContext(KonteringContext);
  const { getActiveAttestKontodelDefsByKodplanId } =
    konteringContext.konteringUtils;
  const kodplanContext = useContext(KodplanContext);

  const attestKodbehorigheterUrval =
    konteringContext.attestKodbehorigheterUrval;

  const kontoDelDef = useMemo(() => {
    const today = new Date();

    return attestKodbehorigheterUrval
      ? getActiveAttestKontodelDefsByKodplanId(
          kodplanContext.activeKodplan?.id ?? '',
          today,
          attestKodbehorigheterUrval,
          null,
          null
        ).find(def => def.ordningsNr === props.ordningsNr)
      : undefined;
  }, [
    attestKodbehorigheterUrval,
    getActiveAttestKontodelDefsByKodplanId,
    kodplanContext.activeKodplan?.id,
    props.ordningsNr,
  ]);

  if (!attestKodbehorigheterUrval) {
    return props.children(null, undefined);
  }

  const kontoDelar = kontoDelDef?.kontodelar;

  if (!kontoDelar || !kontoDelDef) {
    return props.children(null, undefined);
  }

  return props.children(kontoDelar, kontoDelDef);
};

export default GetKontoDelFromOrdningsNr;
